export const useDefaultData = ({Helpers}) => {

    const { getCurrentDate } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormGlobal = {
        idgestion: 0,
        idgestiontipo: 0,
        idcontrato: 0,
        cliente: '',
        dpi: '',
        telefono: '',
        casa: '',
        contrato_dia_pago: '',
        gestion_nuevo_dia_pago: '',
        costo_alquiler: '',
        gestion_descripcion: '',
        monto_devolucion: '',
        cargos_extras_total: '',
        meses_ampliacion: '',
        legalizacion_monto: 0,
        legalizacion_exoneracion: 0,
        legalizacion_pago: 0,
        deposito_total: '',
        aprobacion_check: 'Pendiente Aprobacion',
        aprobacion_fecha: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const optionsAprobacionCheck = [
        { value: 'Aprobado', label: 'Aprobado' },
        { value: 'Rechazado', label: 'Rechazado' },
        { value: 'Pendiente Aprobacion', label: 'Pendiente Aprobacion' },
        { value: 'Devuelto a Gestor', label: 'Devuelto a Gestor' },
    ];

    const defaultFormLegalizationPayment = {
        idmovimiento: '',
        idpago: '',
        idcaja: '',
        idbanco: '',
        movimiento_fecha: getCurrentDate(),
        movimiento_usuario: '',
        movimiento_tipo: '',
        movimiento_monto: '',
        movimiento_moneda: '',
        movimiento_tipo_cambio: '7.8',
        movimiento_quetzales: '',
        movimiento_dolares: '',
        movimiento_observaciones: '',
        boleta_numero: '',
        boleta_foto_originalname: '',
        boleta_foto_filename: '',
        boleta_foto_path: '',

        // // Info aprobacion (solo lectura)
        aprobacion_check: '',
        aprobacion_fecha: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }



    return Object.freeze({
        defaultDataModal,
        defaultFormGlobal,
        optionsAprobacionCheck,
        defaultFormLegalizationPayment
    })
}